<div fxFlex fxLayout="row" fxLayoutAlign="stretch">
  <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <div>{{ filename }}</div>
    <div>{{ size | byteFormat }}</div>
  </div>
  <button (click)="removeAttachment()" mat-icon-button>
    <mat-icon>delete</mat-icon>
  </button>
</div>
